import { useQuery } from '@tanstack/react-query';
import { CustomerInfo, getRevenueCatClient } from '../services/revenueCat';
import useAuthenticatedUser from 'networking/mindfeed/hooks/useAuthenticatedUser';

const fetchCustomerInfo = async (userId: string): Promise<CustomerInfo> => {
  const customerInfo = await getRevenueCatClient().getCustomerInfo(userId);

  return customerInfo;
};

export const useSubscriptionInfo = () => {
  const { authenticatedUser } = useAuthenticatedUser();
  const userId = authenticatedUser?.id;

  return useQuery<CustomerInfo, Error>({
    queryKey: ['customerInfo', userId],
    queryFn: () => fetchCustomerInfo(userId!),
    enabled: !!userId, // Fetch data only when userId is available
    staleTime: 1000 * 60 * 20, // Data will be considered fresh for 20 minutes
    gcTime: 1000 * 60 * 60, // Unused data will be cached for 60 minutes
  });
};
